import { api } from '@/core/api/';

const dashboardUrl = 'api/dashboard';
export default {
  async getDashbord(id, params) {
    return api.get(`${dashboardUrl}/${id}/embeddata`, {
      params,
    });
  },
};
